import React from 'react';
import { useSelector } from 'react-redux';

export default function usePayableSelector() {
  const PayableListData = useSelector((state) => state?.Payable?.list_data?.content) || []; // view data
  const PayableViewData = useSelector((state) => state?.Payable?.view_data) || []; // view data
  return { PayableListData, PayableViewData };
}
